module.exports = __webpack_public_path__ + "static/media/14UNEP19.2fcdaf6d.jpg";